export default __webpack_public_path__ + "a6bab00ec9ad1b091f9f878d5e19cd70.jpg";